import React from 'react';
import { Link } from 'react-router-dom';

const LinkToFullChangeLog = ({ username }) => (
  <Link to={`/admin/profiles/${username}`}>View Full Change Log</Link>
)

export default LinkToFullChangeLog



// WEBPACK FOOTER //
// ./src/components/Admin/Profile/LinkToFullChangeLog.js